<div class="fb-overlay" (click)="onBackdrop($event)">
  <div class="fb-stage" (click)="$event.stopPropagation()">
    <!-- ==================== Illustration ==================== -->
    <!--
      Placeholder artwork. When the real mascot render is available, replace
      this whole <figure> with:
      <figure class="fb-art"><img src="assets/feedback-mascot.png" alt="" /></figure>
    -->
    <figure class="fb-art" aria-hidden="true">
      <svg viewBox="0 0 340 400" role="presentation">
        <defs>
          <linearGradient id="fbBody" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#c9b8fb" />
            <stop offset="55%" stop-color="#a68ef0" />
            <stop offset="100%" stop-color="#8570e2" />
          </linearGradient>

          <linearGradient id="fbFace" x1="0" y1="0" x2="0.4" y2="1">
            <stop offset="0%" stop-color="#eaf0ff" />
            <stop offset="100%" stop-color="#b9c8f5" />
          </linearGradient>

          <linearGradient id="fbBubble" x1="0" y1="0" x2="0.6" y2="1">
            <stop offset="0%" stop-color="#dfe6ff" />
            <stop offset="100%" stop-color="#aab8f7" />
          </linearGradient>

          <linearGradient id="fbHeart" x1="0" y1="0" x2="0.5" y2="1">
            <stop offset="0%" stop-color="#e6ecff" />
            <stop offset="100%" stop-color="#9fb1f4" />
          </linearGradient>

          <radialGradient id="fbShadow">
            <stop offset="0%" stop-color="#8570e2" stop-opacity="0.24" />
            <stop offset="100%" stop-color="#8570e2" stop-opacity="0" />
          </radialGradient>
        </defs>

        <!-- ground shadow -->
        <ellipse cx="150" cy="356" rx="112" ry="24" fill="url(#fbShadow)" />

        <!-- legs -->
        <rect x="112" y="298" width="30" height="52" rx="15" fill="#9a83ec" />
        <rect x="162" y="298" width="30" height="52" rx="15" fill="#8f77e8" />

        <!-- body -->
        <path
          d="M152 60c58 0 100 46 100 108 0 60-42 100-100 100S52 228 52 168C52 106 94 60 152 60z"
          fill="url(#fbBody)"
        />

        <!-- hood highlight -->
        <path
          d="M152 60c34 0 62 16 80 43-22-15-49-23-80-23s-58 8-80 23c18-27 46-43 80-43z"
          fill="#d5c8fd"
          opacity="0.75"
        />

        <!-- face -->
        <ellipse cx="148" cy="176" rx="68" ry="62" fill="url(#fbFace)" />

        <!-- eyes -->
        <ellipse cx="124" cy="170" rx="13" ry="16" fill="#2f2a4a" />
        <ellipse cx="172" cy="170" rx="13" ry="16" fill="#2f2a4a" />
        <circle cx="128" cy="164" r="5" fill="#ffffff" />
        <circle cx="176" cy="164" r="5" fill="#ffffff" />
        <circle cx="120" cy="178" r="2.6" fill="#ffffff" opacity="0.7" />
        <circle cx="168" cy="178" r="2.6" fill="#ffffff" opacity="0.7" />

        <!-- brows -->
        <path
          d="M112 146c6-5 16-6 23-2"
          stroke="#6f63b8"
          stroke-width="4"
          stroke-linecap="round"
          fill="none"
          opacity="0.5"
        />
        <path
          d="M161 144c7-4 17-3 23 2"
          stroke="#6f63b8"
          stroke-width="4"
          stroke-linecap="round"
          fill="none"
          opacity="0.5"
        />

        <!-- blush -->
        <ellipse cx="103" cy="196" rx="12" ry="7" fill="#f0a8c8" opacity="0.45" />
        <ellipse cx="193" cy="196" rx="12" ry="7" fill="#f0a8c8" opacity="0.45" />

        <!-- smile -->
        <path
          d="M134 200c8 9 22 9 30 0"
          stroke="#2f2a4a"
          stroke-width="4.5"
          stroke-linecap="round"
          fill="none"
        />

        <!-- left arm -->
        <path
          d="M64 214c-14 10-18 28-9 41 8 12 24 13 33 3"
          stroke="#9a83ec"
          stroke-width="26"
          stroke-linecap="round"
          fill="none"
        />

        <!-- right arm reaching to the bubble -->
        <path
          d="M232 206c18-4 30-16 33-33"
          stroke="#9a83ec"
          stroke-width="26"
          stroke-linecap="round"
          fill="none"
        />

        <!-- speech bubble -->
        <path
          d="M236 40h68a20 20 0 0 1 20 20v52a20 20 0 0 1-20 20h-40l-20 20v-20h-8a20 20 0 0 1-20-20V60a20 20 0 0 1 20-20z"
          fill="url(#fbBubble)"
        />

        <!-- heart -->
        <path
          d="M270 108c-14-10-24-18-24-29a13 13 0 0 1 24-7 13 13 0 0 1 24 7c0 11-10 19-24 29z"
          fill="url(#fbHeart)"
        />

        <!-- sparkles -->
        <path
          d="M300 62l3 8 8 3-8 3-3 8-3-8-8-3 8-3z"
          fill="#ffffff"
          opacity="0.9"
        />
        <path
          d="M246 66l2 5 5 2-5 2-2 5-2-5-5-2 5-2z"
          fill="#ffffff"
          opacity="0.8"
        />
        <circle cx="308" cy="96" r="3" fill="#ffffff" opacity="0.75" />
      </svg>
    </figure>

    <!-- ==================== Form card ==================== -->
    <div
      class="fb-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="fbTitle"
    >
      <button
        type="button"
        class="fb-close"
        (click)="close()"
        aria-label="Close feedback form"
      >
        <i class="pi pi-times"></i>
      </button>

      <header class="fb-head">
        <h2 id="fbTitle">How was your experience?</h2>
        <p>We value your input to help us improve the Feedback Portal.</p>
      </header>

      <!-- Rating -->
      <div class="fb-rating-box">
        <span class="fb-rating-label">Rate Your Experience</span>

        <div class="fb-stars" (mouseleave)="hoverRating = 0">
          <button
            type="button"
            class="fb-star"
            *ngFor="let star of stars"
            [class.filled]="star <= (hoverRating || rating)"
            (mouseenter)="hoverRating = star"
            (click)="setRating(star)"
            [attr.aria-label]="star + ' star'"
          >
            <i class="pi pi-star-fill"></i>
          </button>
        </div>

        <span class="fb-rating-hint" *ngIf="rating">{{ ratingLabel }}</span>
      </div>

      <!-- Feedback type -->
      <div class="fb-field">
        <label for="fbType">Feedback Type</label>

        <div class="fb-select-wrap">
          <select id="fbType" [(ngModel)]="selectedCategory" name="fbType">
            <option value="" disabled selected>Select a category</option>
            <option
              *ngFor="let category of categories"
              [value]="category.value"
            >
              {{ category.label }}
            </option>
          </select>

          <i class="pi pi-chevron-down"></i>
        </div>
      </div>

      <!-- Message -->
      <div class="fb-field">
        <label for="fbMessage">Tell us more</label>

        <textarea
          id="fbMessage"
          rows="4"
          [(ngModel)]="message"
          name="fbMessage"
          placeholder="Describe your experience or suggest improvements..."
        ></textarea>
      </div>

      <!-- Upload -->
      <div class="fb-field">
        <label>
          Upload Screenshot
          <span class="fb-optional">(Optional)</span>
        </label>

        <div
          class="fb-dropzone"
          [class.dragging]="isDragging"
          [class.has-file]="!!selectedFileName"
          (click)="fileInput.click()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <input
            #fileInput
            type="file"
            accept="image/png,image/jpeg,image/gif"
            hidden
            (change)="onFileSelected($event)"
          />

          <ng-container *ngIf="!selectedFileName">
            <span class="fb-drop-icon"><i class="pi pi-cloud-upload"></i></span>

            <p class="fb-drop-text">
              <span class="fb-drop-accent">Click to upload</span>
              or drag and drop
            </p>

            <p class="fb-drop-hint">PNG, JPG or GIF (max. 10MB)</p>
          </ng-container>

          <div class="fb-file-chip" *ngIf="selectedFileName">
            <i class="pi pi-check-circle"></i>

            <span class="fb-file-name">{{ selectedFileName }}</span>

            <button
              type="button"
              class="fb-file-remove"
              (click)="removeFile(); $event.stopPropagation()"
              aria-label="Remove file"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <button
        type="button"
        class="fb-submit"
        [disabled]="isSubmitting"
        (click)="submitFeedback()"
      >
        <ng-container *ngIf="!isSubmitting">
          Submit Feedback
          <i class="pi pi-send"></i>
        </ng-container>

        <ng-container *ngIf="isSubmitting">
          <i class="pi pi-spin pi-spinner"></i>
          Submitting...
        </ng-container>
      </button>
    </div>
  </div>
</div>
